import React, { useEffect, useState } from 'react';
import taskAPI from '../api/taskAPI';
import UserDashboard from './UserDashboard';
import {
  FaCalendarAlt, FaAlignLeft, FaUpload
} from 'react-icons/fa';
import { MdAssignment, MdGroups } from 'react-icons/md';

const HRDesignTaskManager = () => {
  const [designers, setDesigners] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [formData, setFormData] = useState({
    title: '',
    deadline: '',
    description: '',
  });

  useEffect(() => {
    fetchDesigners();
  }, []);

  const fetchDesigners = async () => {
    try {
      const res = await taskAPI.get('/assignable-workers'); // backend handles role
      setDesigners(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const toggleSelect = (id) => {
    setSelectedIds(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title || !formData.deadline || !formData.description) {
      alert('Fill all fields');
      return;
    }

    if (selectedIds.length === 0) {
      alert('Select at least one designer');
      return;
    }

    try {
      await taskAPI.post('/chain', {
        ...formData,
        assigneeIds: selectedIds,
      });

      alert('✅ Task assigned to designer(s)!');

      setFormData({
        title: '',
        deadline: '',
        description: '',
      });

      setSelectedIds([]);

    } catch (err) {
      alert('❌ Failed to create task');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-100 p-6 pt-20">
      <UserDashboard />

      <h2 className="text-3xl font-bold text-pink-700 text-center mb-6 mt-3">
        HR & Design — Task Manager
      </h2>

      <p className="text-center text-sm text-gray-500 mb-6">
        Assign tasks to <span className="font-semibold text-purple-600">Designers</span>
      </p>

      <div className="max-w-3xl mx-auto bg-white p-6 rounded-xl shadow-lg">

        <h3 className="text-xl font-semibold text-purple-600 mb-4 flex items-center gap-2">
          <MdAssignment /> Assign Task to Designer
        </h3>

        <form onSubmit={handleSubmit} className="space-y-4">

          {/* Title */}
          <div>
            <label className="text-sm font-medium">Task Title</label>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              className="w-full border rounded px-3 py-2"
            />
          </div>

          {/* Deadline */}
          <div>
            <label className="text-sm font-medium">
              <FaCalendarAlt className="inline mr-1" /> Deadline
            </label>
            <input
              type="date"
              value={formData.deadline}
              onChange={(e) => setFormData({ ...formData, deadline: e.target.value })}
              className="w-full border rounded px-3 py-2"
            />
          </div>

          {/* Description */}
          <div>
            <label className="text-sm font-medium">
              <FaAlignLeft className="inline mr-1" /> Description
            </label>
            <textarea
              rows={3}
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="w-full border rounded px-3 py-2"
            />
          </div>

          {/* Designers */}
          <div>
            <label className="text-sm font-medium mb-2 block">
              <MdGroups className="inline mr-1" /> Select Designer(s)
            </label>

            <div className="border rounded max-h-40 overflow-y-auto">
              {designers.length === 0 ? (
                <p className="p-3 text-gray-400">No designers found</p>
              ) : (
                designers.map(d => (
                  <label
                    key={d._id}
                    className="flex items-center gap-3 px-3 py-2 hover:bg-purple-50"
                  >
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(d._id)}
                      onChange={() => toggleSelect(d._id)}
                    />
                    <span>{d.username}</span>
                  </label>
                ))
              )}
            </div>
          </div>

          <button
            type="submit"
            className="w-full bg-purple-600 text-white py-2 rounded hover:bg-purple-700"
          >
            Assign Task
          </button>

        </form>
      </div>
    </div>
  );
};

export default HRDesignTaskManager;